import { buildUrl, getSlugFromPage } from '@eliadmin/core/src/utils/url-utils';

export const ROUTES_OVERRIDES = {
  // DELIVERY_PAYMENT: () => getSlugFromPage('delivery-payment'),
  // PRODUCT_RETURN: () => getSlugFromPage('product-return'),
  MY_DATA: () => getSlugFromPage('profile.data'),
  ESHOP: () => getSlugFromPage('eshop'),
  PRODUCT_COMPARISON: () => getSlugFromPage('product-comparison'),
  // Core points this at `manufacturer.[slug]` with a TODO; Mediatip has its own A–Z page.
  MANUFACTURERS: () => getSlugFromPage('manufacturers'),
  /**
   * Manufacturer pages resolve through the generic `/:slug` route (e.g. `/acer`). No
   * `manufacturer.[slug]` slug is configured, so core's helper returned the home page.
   */
  MANUFACTURER: ({ slug, page }: { slug: string; page?: number }) =>
    buildUrl(getSlugFromPage('slug'), { params: { slug }, search: { page } }),
  /**
   * No CMS page carries the `tos` template, so `getSlugFromPage('tos')` returned the home slug and
   * the checkout/registration terms link fell back to core's `/vseobecne-obchodne-podmienky` (404).
   * Preferred fix: assign the `tos` template to "Obchodné podmienky" in eliadmin; until then the
   * existing page is used.
   */
  TOS: () => {
    const slug = getSlugFromPage('tos');
    return slug && slug !== '/' && slug !== getSlugFromPage('home') ? slug : '/obchodne-podmienky';
  },
};
